/* Shadow Flow landing pages: shared behavior. No dependencies. */
(function () {
  'use strict';
  var body = document.body;
  var page = body.getAttribute('data-lp-page') || 'lp';
  var VARIANT_ID = body.getAttribute('data-variant-id');

  /* ---------- tracking hooks (Meta Pixel / CAPI / dataLayer) ---------- */
  function track(kind, name, params) {
    try { if (window.fbq) window.fbq(kind, name, params || {}); } catch (e) {}
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name, lp_page: page }, params || {}));
  }
  // The quiz fires ViewContent itself when a result page is shown.
  if (!document.querySelector('[data-quiz]')) {
    track('track', 'ViewContent', { content_ids: [VARIANT_ID], content_type: 'product', content_name: 'Shadow Flow' });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-cta]');
    if (!el) return;
    track('trackCustom', 'LPCtaClick', { cta_section: el.getAttribute('data-cta') });
  });
  // CTA links all point at the on-page buy box (#offer). Caught in the capture phase so store apps
  // that also hijack #links (with their own header offset) never see the click; we track it here instead.
  window.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    var target = a && a.getAttribute('href').length > 1 && document.getElementById(a.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    e.stopPropagation();
    if (a.hasAttribute('data-cta')) track('trackCustom', 'LPCtaClick', { cta_section: a.getAttribute('data-cta') });
    glideTo(target);
  }, true);

  // Timer-driven glide that re-aims every step, so images loading mid-scroll can't make it miss.
  function glideTo(el) {
    var from = scrollY, t0 = Date.now(), dur = 700;
    var margin = parseFloat(getComputedStyle(el).scrollMarginTop) || 0;
    (function step() {
      var p = Math.min(1, (Date.now() - t0) / dur);
      var ease = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      var dest = scrollY + el.getBoundingClientRect().top - margin;
      window.scrollTo({ top: from + (dest - from) * ease, behavior: 'instant' });
      if (p < 1) setTimeout(step, 16);
    })();
  }

  /* ---------- UTM pass-through: carry the ad's utm_* params onto every CTA link ---------- */
  var incoming = new URLSearchParams(location.search);
  document.querySelectorAll('a[data-cta]').forEach(function (a) {
    if ((a.getAttribute('href') || '').charAt(0) === '#') return; // in-page links (e.g. #offer) stay as they are
    try {
      var url = new URL(a.getAttribute('href'), location.origin);
      incoming.forEach(function (v, k) { if (/^utm_/.test(k) && !url.searchParams.has(k)) url.searchParams.set(k, v); });
      url.searchParams.set('utm_content', page);
      a.setAttribute('href', url.pathname + url.search + url.hash);
    } catch (err) {}
  });
  /* ---------- buy buttons go straight to checkout (no cart page) ---------- */
  // Each click swaps any Shadow Flow already in the cart for the chosen pack, so Back + buy again can't stack bottles.
  // Without JS the form still posts to /cart/add and Shopify forwards to /checkout via return_to.
  // Caught in the window capture phase: the Zipify cart drawer app hijacks /cart/add forms and opens its drawer instead.
  var offerForms = document.querySelectorAll('form[data-offer-form]');
  offerForms.forEach(function (f) {
    var keep = f.querySelector('input[name="return_to"]');
    if (keep) keep.value = '/checkout';
  });
  addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('form[data-offer-form] button[type="submit"]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    track('trackCustom', 'LPCtaClick', { cta_section: btn.getAttribute('data-cta') });
    buy(btn.form);
  }, true);
  addEventListener('submit', function (e) {
    if (!e.target.matches || !e.target.matches('form[data-offer-form]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    buy(e.target);
  }, true);
  function buy(f) {
    if (f.classList.contains('is-busy')) return;
    setBusy(f, true);
    var id = Number(f.querySelector('input[name="id"]').value);
    var item = { id: id, quantity: Number(f.querySelector('input[name="quantity"]').value) || 1 };
    var plan = f.querySelector('input[name="selling_plan"]');
    if (plan && !plan.disabled && plan.value) item.selling_plan = Number(plan.value);
    var json = function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); };
    var post = function (url, data) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) }).then(json);
    };
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(json)
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (line) { if (line.variant_id === id) updates[line.key] = 0; });
        return Object.keys(updates).length ? post('/cart/update.js', { updates: updates }) : null;
      })
      .then(function () { return post('/cart/add.js', { items: [item] }); })
      .then(function () { location.href = '/checkout'; })
      .catch(function () { f.submit(); }); // plain form post, still lands on checkout
  }
  function setBusy(f, on) {
    f.classList.toggle('is-busy', on);
    var btn = f.querySelector('button[type="submit"]');
    if (btn) btn.disabled = on;
  }
  // Coming back from checkout restores the page from cache: make the buttons usable again
  addEventListener('pageshow', function () { offerForms.forEach(function (f) { setBusy(f, false); }); });

  /* ---------- images: show a labeled placeholder until the real file exists ---------- */
  document.querySelectorAll('.lp-img img').forEach(function (img) {
    var mark = function () { img.parentNode.classList.add('is-missing'); };
    if (img.complete && img.naturalWidth === 0 && img.getAttribute('src')) mark();
    img.addEventListener('error', mark);
  });
  document.querySelectorAll('[data-bg]').forEach(function (el) {
    var src = el.getAttribute('data-bg');
    var probe = new Image();
    probe.onload = function () { el.style.backgroundImage = 'url("' + src + '")'; };
    probe.onerror = function () { el.classList.add('is-missing'); };
    probe.src = src;
  });

  /* ---------- offer selector: radio cards set the cart quantity ---------- */
  // Seal plans from the layout (keyed by days: 30 = 1 bottle, 60 = 2, 90 = 3; price per bottle in cents).
  // The fallback only matters in the local preview, where Liquid doesn't run.
  var PLANS = {};
  try { PLANS = JSON.parse(document.getElementById('sf-sub-plans').textContent); } catch (e) {}
  if (!PLANS['30']) PLANS = { 30: { id: 6399656184, price: 4049 }, 60: { id: 6400114936, price: 3149 }, 90: { id: 6400147704, price: 2519 } };
  var SUB_BADGES = { 1: 'SAVE 10%', 2: 'SAVE AN EXTRA 5%', 3: 'SAVE 4% MORE' };
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };

  document.querySelectorAll('[data-offer]').forEach(function (group) {
    var formId = group.getAttribute('data-offer');
    var form = document.getElementById(formId);
    var qty = form && form.querySelector('input[name="quantity"]');
    var planInput = null;
    if (form) {
      planInput = document.createElement('input');
      planInput.type = 'hidden';
      planInput.name = 'selling_plan';
      planInput.disabled = true; // one-time purchase unless a Subscribe & Save card is active
      form.appendChild(planInput);
    }
    var activating = false;
    // Sections render data-no-subscribe when their "Show Subscribe & Save" setting is off
    var noSubscribe = group.hasAttribute('data-no-subscribe');

    // Subscribe & Save card under each bundle card
    group.querySelectorAll('.lp-offer-opt').forEach(function (opt) {
      if (noSubscribe) return;
      var radio = opt.querySelector('input[type="radio"]');
      var n = Number(radio.value);
      var plan = PLANS[String(n * 30)];
      if (!plan) return;
      var col = document.createElement('div');
      col.className = 'lp-offer-col';
      opt.parentNode.insertBefore(col, opt);
      col.appendChild(opt);
      var days = n * 30;
      var sub = document.createElement('button');
      sub.type = 'button';
      sub.className = 'lp-sub';
      sub.setAttribute('aria-pressed', 'false');
      sub.setAttribute('data-plan', plan.id);
      sub.setAttribute('data-qty', n);
      sub.innerHTML =
        '<span class="lp-sub-head"><span class="lp-sub-check" aria-hidden="true"></span>' +
        '<span class="lp-sub-title">Subscribe &amp; Save</span>' +
        '<span class="lp-sub-badge">' + SUB_BADGES[n] + '</span>' +
        '<span class="lp-sub-caret" aria-hidden="true"></span></span>' +
        '<span class="lp-sub-body">' +
        '<span class="lp-sub-price">' + money(plan.price * n) + ' <small>every ' + days + ' days</small></span>' +
        '<span class="lp-sub-per">' + money(plan.price) + ' per bottle</span>' +
        '<span class="lp-sub-fine">' + (n > 1 ? 'Free shipping. ' : '') + 'Ships every ' + days + ' days. 2-payment minimum, then cancel anytime.</span>' +
        '</span>';
      col.appendChild(sub);
      sub.addEventListener('click', function () {
        var on = sub.getAttribute('aria-pressed') !== 'true';
        activating = true;
        if (on && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
        activating = false;
        setSub(on ? sub : null);
      });
    });

    function setSub(active) {
      group.querySelectorAll('.lp-sub').forEach(function (s) { s.setAttribute('aria-pressed', s === active ? 'true' : 'false'); });
      group.classList.toggle('is-subscribing', !!active);
      if (planInput) {
        planInput.disabled = !active;
        planInput.value = active ? active.getAttribute('data-plan') : '';
      }
      sync();
    }
    function sync() {
      var on = group.querySelector('input[type="radio"]:checked');
      if (on && qty) qty.value = on.value;
      var subbing = planInput && !planInput.disabled;
      document.querySelectorAll('[data-offer-summary="' + formId + '"]').forEach(function (s) {
        s.textContent = on ? on.getAttribute('data-label') + (subbing ? ', subscribe' : '') : '';
      });
    }
    // Picking a bundle card (not its Subscribe card) means a one-time purchase.
    group.addEventListener('change', function () { if (!activating) setSub(null); else sync(); });
    sync();
  });
  document.querySelectorAll('[data-submit-offer]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = document.getElementById(btn.getAttribute('data-submit-offer'));
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });

  /* ---------- sticky mobile bar ---------- */
  var sticky = document.querySelector('.lp-sticky');
  if (sticky) {
    var mode = sticky.getAttribute('data-show');
    var hideNear = document.getElementById('offer');
    var anchor = document.querySelector('[data-sticky-anchor]');
    var update = function () {
      var show;
      if (mode === 'scroll') {
        var max = document.documentElement.scrollHeight - innerHeight;
        show = max > 0 && scrollY / max >= 0.3;
      } else {
        show = !!anchor && anchor.getBoundingClientRect().bottom < 0;
      }
      if (hideNear) {
        var r = hideNear.getBoundingClientRect();
        if (r.top < innerHeight * 0.85 && r.bottom > innerHeight * 0.15) show = false;
      }
      sticky.classList.toggle('is-visible', show);
    };
    addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------- advertorial sidebar: appears after the hero ---------- */
  var side = document.querySelector('.adv-side');
  var hero = document.querySelector('[data-hero]');
  if (side && hero) {
    var sideCheck = function () { side.classList.toggle('is-visible', hero.getBoundingClientRect().bottom < 0); };
    addEventListener('scroll', sideCheck, { passive: true });
    sideCheck();
  }

  /* ---------- self-check list (visual only, nothing is saved) ---------- */
  document.querySelectorAll('.sp-check button').forEach(function (b) {
    b.addEventListener('click', function () {
      b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
    });
  });

  /* ---------- announcement ticker (mobile) ---------- */
  var msgs = document.querySelectorAll('.sp-announce .msgs span');
  if (msgs.length > 1) {
    var i = 0;
    msgs[0].classList.add('is-active');
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 3500);
  }
})();
